import ModalsContext from "context/modalsContext";
import { useContext } from "react";

export const useModalsContext = () => useContext(ModalsContext);
